<div [class.sidebar-rail]="navServices.collapseSidebar" [class]="ui.header">
  <div [class]="ui.wrapper">
    <div [class]="ui.toggleWrapper">
      <button
        type="button"
        (click)="sidebarToggle()"
        [class]="ui.toggle"
        data-testid="nav-open-toggle"
        aria-label="Toggle sidebar"
      >
        <app-feather-icons [icon]="'align-center'" class="align-middle"></app-feather-icons>
      </button>
    </div>
    <div [class]="ui.spacer"></div>
    <div [class]="ui.navRight">
      <ul [class]="ui.menus">
        @if(isDemoMode()) {
        <div class="upgrade-btn text-right">
          <a [routerLink]="['/upgrade']" class="btn border-1 py-2 btn-outline-dark-2x">
            {{ 'CONTACT_DETAILS.CONTACT_US' | translate }}
          </a>
        </div>
        }
        <li [class]="ui.profile" data-testid="profile-menu" onClick="return true">
          <app-my-account></app-my-account>
        </li>
      </ul>
    </div>
  </div>
</div>
